import { Component, ComponentInterface, Element, Prop, h, VNode } from '@stencil/core';

import { UniHostTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

import { uniAdjustClass } from '../utils/adjust.classes';

@Component({
  tag: 'uni-adjust',
  styleUrl: '../styles/adjust.css',
})
export class UniAdjustComponent implements ComponentInterface {

  @Element() el!: HTMLElement;

  @Prop({ reflect: true }) asideStart: boolean = false;

  @Prop({ reflect: true }) sidebarStart: boolean = false;

  @Prop({ reflect: true }) asideEnd: boolean = false;

  @Prop({ reflect: true }) sidebarEnd: boolean = false;

  render(): VNode {
    const classes = uniAdjustClass(this.asideStart, this.sidebarStart, this.asideEnd, this.sidebarEnd);

    return UniHostTemplate({ classes }, <slot />);
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
